var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.08 159.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bfc291b2-bb80-46c3-8cbc-bb8522d88991{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b87d151f-ec7b-431a-8058-945789b038fc",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bfc291b2-bb80-46c3-8cbc-bb8522d88991",
    d: "M8.43,6.83l101.39,58.5a3.65,3.65,0,0,1,1.83,3.16V117.2a3.65,3.65,0,0,1-1.79,3.14L55,152.84"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.2d7dfb54.svg";
export { ForwardRef as ReactComponent };